module.exports = __webpack_public_path__ + "img/symbol-1.27402ab3.svg";